export enum TypographySize {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}
